module.exports = require('./media_control')



/** WEBPACK FOOTER **
 ** ./src/components/media_control/index.js
 **/